import { render, staticRenderFns } from "./Declined.vue?vue&type=template&id=13bf3610&scoped=true&"
import script from "./Declined.vue?vue&type=script&lang=js&"
export * from "./Declined.vue?vue&type=script&lang=js&"
import style0 from "./Declined.vue?vue&type=style&index=0&id=13bf3610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf3610",
  null
  
)

export default component.exports